export const SIDEBAR_BANNERS = [
    {
        id: 1,
        img: '../img/BANNER_1.png',
        title: 'Получи бонус',
        link: {
            text: 'Вперед',
            url: '/'
        }
    },
    {
        id: 2,
        img: '../img/BANNER_2.png',
        title: 'Кэшбэк при пополнении',
        link: {
            text: 'Активировать',
            url: '/'
        }
    },
];